import axios from "axios";
import { getAdminLang, getlocalAdminToken } from "./localstorage-service";
import * as constant from "./constants";
import { emptyCheck } from "./utilities";

const hostUrl = constant.API_URL;

export function getAdminToken(username, password) {
  const axiosNewConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  return axios
    .post(
      `${hostUrl}/Token?admin=true`,
      `grant_type=password&username=${username}&password=${password}`,
      axiosNewConfig
    )
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      throw error;
    });
}

function getApi(controller, requestParam = null, methodName = null) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalAdminToken()}`,
    },
  };
  let url = "";
  if (requestParam === null) {
    url = `${hostUrl}/${getAdminLang()}/${controller}/${methodName === null ? "Get" : methodName}`;
  } else {
    url = `${hostUrl}/${getAdminLang()}/${controller}/${methodName === null ? "Get" : methodName}?${requestParam}`;
  }
  return axios
    .get(url, axiosConfig)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      throw error;
    });
}

function createUpdateApi(controller, data, action, method = "") {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalAdminToken()}`,
    },
  };

  if (action === "create") {
    const methodName = emptyCheck(method) ? "Create" : method;
    return axios
      .post(`${hostUrl}/${getAdminLang()}/${controller}/${methodName}`, JSON.stringify(data), axiosConfig)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  } else if (action === "update") {
    const methodName = emptyCheck(method) ? "Update" : method;
    return axios
      .put(`${hostUrl}/${getAdminLang()}/${controller}/${methodName}`, JSON.stringify(data), axiosConfig)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  } else {
    return null;
  }
}

function deleteApi(controller, id, method = "") {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalAdminToken()}`,
    },
  };
  const methodName = emptyCheck(method) ? "Delete" : method;
  return axios
    .delete(`${hostUrl}/${getAdminLang()}/${controller}/${methodName}?id=${id}`, axiosConfig)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      throw error;
    });
}

function uploadApi(controller, action, data) {
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${getlocalAdminToken()}`,
      // 'content-type': 'multipart/form-data'
    },
  };
  return axios
    .post(`${hostUrl}/${getAdminLang()}/${controller}/${action}`, data, axiosConfig)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      throw error;
    });
}

/*Languages*/
export function getLanguages() {
  return getApi("Language");
}

/*Modules*/
export function getModules() {
  return getApi("Module");
}

export function getBreadCrumbInformation(moduleId, learningCategoryId, contentCategoryId) {
  return getApi(
    "Module",
    `moduleId=${moduleId}&learningCategoryId=${learningCategoryId}&contentCategoryId=${contentCategoryId}`,
    "GetBreadCrumbInformation"
  );
}

export function getCoursePreview(moduleid) {
  return getApi("Module", "moduleId=" + moduleid, "CoursePreview");
}

export function publishModule(moduleid) {
  return getApi("Module", "moduleId=" + moduleid, "PublishModule");
}

export function unPublishModule(moduleid) {
  return getApi("Module", "moduleId=" + moduleid, "UnPublishModule");
}

export function createModule(data) {
  return createUpdateApi("Module", data, "create");
}

export function updateModule(data) {
  return createUpdateApi("Module", data, "update");
}

export function deleteModule(id) {
  return deleteApi("Module", id);
}

export function removePreview(path) {
  return getApi("Module", "path=" + path, "RemovePreview");
}

/*Caegories*/
export function getCategories(moduleid) {
  return getApi("Category", "moduleId=" + moduleid);
}

export function createCategory(data) {
  return createUpdateApi("Category", data, "create");
}

export function updateCategory(data) {
  return createUpdateApi("Category", data, "update");
}

export function deleteCategory(id) {
  return deleteApi("Category", id);
}

export function uploadCategoryImage(data) {
  return uploadApi("Upload", "PostCategoryImage", data);
}

/* Countries */
export function getCountries() {
  return getApi("Country");
}

export function createCountry(data) {
  return createUpdateApi("Country", data, "create");
}

export function updateCountry(data) {
  return createUpdateApi("Country", data, "update");
}

export function deleteCountry(id) {
  return deleteApi("Country", id);
}

/* States */
export function getAllStates() {
  return getApi("State");
}
export function getStates(id) {
  return getApi("State", `countryId=${id}`);
}

export function createState(data) {
  return createUpdateApi("State", data, "create");
}

export function updateState(data) {
  return createUpdateApi("State", data, "update");
}

export function deleteState(id) {
  return deleteApi("State", id);
}

/* JobRoleGroups */
export function getJobRoleGroups() {
  return getApi("JobRoleGroup");
}

export function createJobRoleGroup(data) {
  return createUpdateApi("JobRoleGroup", data, "create");
}

export function updateJobRoleGroup(data) {
  return createUpdateApi("JobRoleGroup", data, "update");
}

export function deleteJobRoleGroup(id) {
  return deleteApi("JobRoleGroup", id);
}

/* JobRole */
export function getJobRoles(id) {
  return getApi("JobRole", `jobRoleGroupId=${id}`);
}

export function createJobRole(data) {
  return createUpdateApi("JobRole", data, "create");
}

export function updateJobRole(data) {
  return createUpdateApi("JobRole", data, "update");
}

export function deleteJobRole(id) {
  return deleteApi("JobRole", id);
}

/* Subcategory / Learning Categories */
export function getSubCategories(categoryid) {
  return getApi("SubCategory", `categoryId=${categoryid}`);
}

export function createSubCategory(data) {
  return createUpdateApi("SubCategory", data, "create");
}

export function updateSubCategory(data) {
  return createUpdateApi("SubCategory", data, "update");
}

export function deleteSubCategory(id) {
  return deleteApi("SubCategory", id);
}

export function uploadLearningCategoryImage(data) {
  return uploadApi("Upload", "PostLearningCategoryImage", data);
}

/*Video Category*/

export function getVideoCategories(islearning, moduleid, categoryid, subcategoryid) {
  return getApi(
    "VideoCategory",
    `isLearning=${islearning}&moduleId=${moduleid}&categoryId=${categoryid}&subCategoryId=${subcategoryid}`
  );
}

export function createVideoCategory(data) {
  return createUpdateApi("VideoCategory", data, "create");
}

export function updateVideoCategory(data) {
  return createUpdateApi("VideoCategory", data, "update");
}

export function deleteVideoCategory(id) {
  return deleteApi("VideoCategory", id);
}

/*Video*/

export function getVideoTypes() {
  return getApi("VideoType");
}

export function getVideos(islearning, categoryid, subcategoryid, videocategoryid) {
  return getApi(
    "Video",
    `islearning=${islearning}&categoryid=${categoryid}&subcategoryid=${subcategoryid}&videocategoryid=${videocategoryid}`,
    "GetVideosBE"
  );
}

export function createVideo(data) {
  return createUpdateApi("Video", data, "create");
}

export function updateVideo(data) {
  return createUpdateApi("Video", data, "update");
}

export function deleteVideo(id) {
  return deleteApi("Video", id);
}

export function uploadVideoDocument(data, type = "") {
  return uploadApi("Upload", `PostVideoDocument?type=${type}`, data);
}

/*Translation*/

export function getMiscs() {
  return getApi("Misc");
}

export function createMisc(data) {
  return createUpdateApi("Misc", data, "create");
}

export function updateMisc(data) {
  return createUpdateApi("Misc", data, "update");
}

export function deleteMisc(id) {
  return deleteApi("Misc", id);
}

/*Users*/

export function getUsers() {
  return getApi("User");
}

export function createUser(data) {
  return createUpdateApi("User", data, "create");
}

export function updateUser(data) {
  return createUpdateApi("User", data, "update");
}

export function deleteUser(id) {
  return deleteApi("User", id);
}

export function changeUserLanguage(data) {
  return createUpdateApi("User", data, "update", "ChangeUserLanguage");
}

/* Assignment */

export function getAssignment(id) {
  return getApi("Assignment", `subcategoryid=${id}`, "GetBE");
}

export function getVideosBySubCategory(id) {
  return getApi("Video", `subcategoryid=${id}`, "GetVideosBySubCategory");
}
export function getEmptyQuestionObject(id) {
  return getApi("Assignment", `subcategoryid=${id}`, "GetEmptyQuestion");
}

export function saveAssignment(data) {
  return createUpdateApi("Assignment", data, "update");
}

export function deleteQuestion(id) {
  return deleteApi("Assignment", id);
}

export function deleteAnswer(id) {
  return deleteApi("Assignment", id, "DeleteAnswer");
}

export function getEmptyAnswerObject(id) {
  return getApi("Assignment", `id=${id}`, "GetBlankAnswer");
}

/*Constant*/
export function getConstants() {
  return getApi("Constant");
}

export function updateConstant(data) {
  return createUpdateApi("Constant", data, "update");
}

/* Download */
export function downloadLmsPackage(moduleid) {
  return getApi("Download", "moduleId=" + moduleid, "DownloadLms");
}



// WEBPACK FOOTER //
// ./src/data-service-admin.js